export default __webpack_public_path__ + "static/3-3-postlaunch-477ff841c0fcd59113ff6aec2ff9e3d1.gif";